<template>
  <div class="shipmentair">
    <form>
      <div class="row m-0 navigation">
        <b-button-group class="row mx-0 px-4 navigation">
          <b-button @click.prevent="ButtonPrev()">
            <img  src = "@/assets/image/icon/icon-rectangle.svg">
            Back
          </b-button>
          <b-button @click.prevent="ButtonNext()">
            Next
            <img  src = "@/assets/image/icon/icon-rectangle.svg">
          </b-button>
        </b-button-group>
      </div>
      <div class="shipmentair__tabs" style="max-width: 950px">
        <b-card no-body>
          <b-tabs v-model="tabIndex" align="center">
            <b-tab title="Air Cargo" :title-link-class="linkClass(0)">
              <HeaderShipmentType :dataHeader="currentDataHeader('AIRCARGO')" />
              <div class="shipmentair__tabs--contain">
                <p class="fontstyle__default--blue mb-3">Enter Your Shipment Data</p>
                  <ShipmentData
                      @setType='setType'
                      @calcTotalShipment='calcTotalShipment'
                      @checkError='checkError'
                      :optionQtyUnit="optionQtyUnit"
                      :item="loadsForm" />
                  <div v-if="error.loadsCargo" class="fontstyle__errormsg">
                    Required
                  </div>
              </div>
            </b-tab>
            <b-tab title="Air Courier" :title-link-class="linkClass(1)">
              <HeaderShipmentType :dataHeader="currentDataHeader('AIRCOURIER')" />
              <div class="shipmentair__tabs--contain">
                <p class="fontstyle__default mb-3">Enter Your Shipment Data</p>
                 <ShipmentData
                    @setType='setType'
                    @calcTotalShipment='calcTotalShipment'
                    @checkError='checkError'
                    :optionQtyUnit="optionQtyUnit"
                    :item="loadsForm" />
                  <div v-if="error.loadsCourier" class="fontstyle__errormsg">
                    Required
                  </div>
              </div>
            </b-tab>         
          </b-tabs>
        </b-card>
      </div>
    </form>
  </div>
</template>

<script>
import { UNIT_COMMODITY_QUANTITY } from '@/constant/options_list'
import HeaderShipmentType from '@/components/contract/components/HeaderShipmentType'
import ShipmentData from '@/components/contract/components/ShipmentData'

export default {
  name: 'shipment_air',
  props: {
  },
  components: {
    HeaderShipmentType,
    ShipmentData
  },
  data () {
    return {
      tabIndex: 0,
      header: {
        id: 1,
        subtitle: 'Air cargo'
      },
      errorData: {
        errorsCargo: false,
        errorsCourier: false,
        errorsBreakbulk: false
      },
      optionQtyUnit: UNIT_COMMODITY_QUANTITY,
      data: {
        shipment_type: 'AIRCARGO',
        estimateddimention: '',
        totalshipment: '',
        total_weight: '',
        service_head: 'AIR',
        service_sub_type: '',
        total_quantity: '',
        lengthdimension: 0,
        widthdimension: 0,
        heightdimension: 0,
        satuan: 'Packages'
      },
      loadsForm: {
        totalshipment: null,
        total_quantity: null,
        total_weight: null,
        satuan: 'Packages',
        size: {
          length: '',
          width: '',
          height: ''
        }
      },
      totalWeightPerShipment: 0,
      totalWeight: 0,
      totalShipment: 0,

      type: 'cargo',
      totalUnit: 0,
      totalVolumetric: 0,
      
      units: 'Packages',
      isCargo: true,
      isCourier: false,
      isBreakbulk: false,
      error: {
        loadsCargo: false,
        loadsCourier: false
      }

    }
  },
  created () {
    this.chooseAir(this.checkIndexType(0)) // set default when refresh
  },
  methods: {
    // -- function -- //
    linkClass (idx) { // tab selected class
      if (this.tabIndex === idx) {
        return ['selectedtab']
      } else {
        return ['blocktab']
      }
    },

    checkIndexType (idx) {
      if (idx === 0) {
        return 'cargo'
      } else if (idx === 1) {
        return 'courier'
      }
    },

    currentDataHeader (type) {
      let data = {}
      if (type === 'AIRCARGO') {
        data = {
          shipmenttype: 'AIR CARGO',
          img: require('@/assets/image/icon/icon-air-cargo.svg'),
          text: 'End to end service for your medium to large quantities shipment',
          InfoShipment: [
            { title: 'Estimate Weight/Shipment', value: `${this.totalWeightPerShipment} Kg` }
          ]
        }
      } else if (type === 'AIRCOURIER') {
        data = {
          shipmenttype: 'AIR COURIER',
          img: require('@/assets/image/icon/icon-air-courier.svg'),
          text: 'End to end service for your small quantities shipment',
          InfoShipment: [
            { title: 'Estimate Weight/Shipment', value: `${this.totalWeightPerShipment} Kg` }
          ]
        }
      }
      return data
    },

    roundToHalf (value) {
      const converted = parseFloat(value) // Make sure we have a number
      let decimal = (converted - parseInt(converted, 10))
      decimal = Math.round(decimal * 10)
      if (decimal === 5) { return (parseInt(converted, 10) + 0.5) }
      if ((decimal < 1) || (decimal > 5)) {
        return Math.round(converted)
      }
      return (parseInt(converted, 10) + 0.5)
    },

    calcVM (item) {
      const size = item.size
      let vm = 1
      let volume = parseInt(size.length) * parseInt(size.width) * parseInt(size.height)

      if (this.type === 'cargo') {
        vm = Math.ceil((volume * item.total_quantity) / 6000)
      } else {
        vm = (volume * item.total_quantity) / 5000
      }
      return !isNaN(vm) ? vm : 0
    },

    calcTotalShipment () {
      const ojct = this.loadsForm
      let tempTotal = 0
      let total = 0 
      if (ojct.total_weight && ojct.totalshipment && ojct.total_quantity) {
        tempTotal = ojct.total_weight * ojct.total_quantity
        total = this.type === 'courier'
          ? this.roundToHalf(tempTotal) / parseInt(ojct.totalshipment)
          : Math.ceil(tempTotal) / parseInt(ojct.totalshipment)
      }
      this.totalWeightPerShipment = total.toFixed(2)
    },

    pushData () {
      this.$emit('inputData', this.data)
    },

    chooseAir (type) { // set type name
      this.isCargo = type === 'cargo'
      this.isCourier = type === 'courier'
      this.type = type

      this.header.subtitle = 'Air ' + type
      this.data.shipment_type = ('Air' + type).toUpperCase()

      this.$emit('inputData', this.data)
      this.$emit('chgHeader', this.header)
    },

    setType (item) {
      this.loadsForm.satuan = item.type
    },

    resetUnselectTab () {
      this.loadsForm = {
        totalshipment: null,
        total_quantity: null,
        total_weight: null,
        satuan: 'Packages',
        size: {
          length: null,
          width: null,
          height: null
        }
      }
    },

    checkError () {
      const data = this.loadsForm
      const dataSize = this.loadsForm.size
      if (!data.totalshipment && !data.total_quantity && !data.total_weight && 
          !dataSize.height && !dataSize.width && !dataSize.length) {
        if (this.type === 'cargo') { this.error.loadsCargo = true }
        if (this.type === 'courier') { this.error.loadsCourier = true }
      } else {
        this.error = {
          loadsCargo: false,
          loadsCourier: false
        }
      }
    },

    ButtonNext () {
      this.checkError()
      if ((!this.error.loadsCargo && this.type === 'cargo') ||
          (!this.error.loadsCourier && this.type === 'courier')) {
        this.data.estimateddimention = this.calcVM(this.loadsForm)
        this.data.lengthdimension = parseFloat(this.loadsForm.size.length)
        this.data.widthdimension = parseFloat(this.loadsForm.size.width)
        this.data.heightdimension = parseFloat(this.loadsForm.size.height)
        this.data.total_quantity = parseFloat(this.loadsForm.total_quantity)
        this.data.total_weight = parseFloat(this.loadsForm.total_weight)
        this.data.totalshipment = parseFloat(this.loadsForm.totalshipment)
        this.data.satuan = this.loadsForm.satuan 
        this.pushData()
        this.$emit('tabIndex')
      }
    },

    ButtonPrev () {
      this.$emit('tabIndexPrev')
    }
  },
  mounted () {
    this.$emit('chgHeader', this.header)
    this.$emit('inputData', this.data)
  },
  watch: {
    tabIndex (idx) {
      this.chooseAir(this.checkIndexType(idx))
      this.resetUnselectTab()
    },
    type (newData, oldData) {
      if (newData !== oldData) {
        this.calcTotalShipment()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/contract/ShipmentAir.vue